import EmptyRouterView from './../views/administrative/EmptyRouterView.vue'
import BedsHome from './../views/administrative/beds/BedsHome.vue'
import Home from './../views/administrative/Home.vue'
import ReportTable from './../views/administrative/ReportTable.vue'

export const routes = [
  { path: '/administrative', 
    component: EmptyRouterView,
    children: [
      {
        path:'camas',
        name:'administrativeBeds',
        component:BedsHome,
      },
      {
        path:'reporte',
        name:'administrativeReport',
        component:ReportTable,
      },
      {
        path: '',
        name: 'administrativeHome', 
        component: Home,
      },
    ]
  },
]